module.exports = __webpack_public_path__ + "img/badge_salabam_travel_train.9d722850.jpg";